// Tema 1
export const primary = {
  100: 'hsl(186, 100%, 94%)',
  200: 'hsl(185, 94%, 87%)',
  300: 'hsl(184, 80%, 74%)',
  400: 'hsl(184, 65%, 59%)',
  500: 'hsl(185, 57%, 50%)',
  600: 'hsl(185, 62%, 45%)',
  700: 'hsl(184, 77%, 34%)',
  800: 'hsl(185, 81%, 29%)',
  900: 'hsl(185, 84%, 25%)',
  1000: 'hsl(184, 91%, 17%)',
};
export const neutral = {
  100: 'hsl(210, 36%, 96%)',
  150: 'hsl(211, 34%, 93%)',
  200: 'hsl(212, 33%, 89%)',
  300: 'hsl(210, 31%, 80%)',
  400: 'hsl(211, 27%, 70%)',
  500: 'hsl(209, 23%, 60%)',
  600: 'hsl(210, 22%, 49%)',
  700: 'hsl(209, 28%, 39%)',
  800: 'hsl(209, 34%, 30%)',
  900: 'hsl(211, 39%, 23%)',
  1000: 'hsl(209, 61%, 16%)',
};

export const indigo = {
  100: 'hsl(221, 68%, 93%)',
  200: 'hsl(221, 78%, 86%)',
  300: 'hsl(224, 67%, 76%)',
  400: 'hsl(225, 57%, 67%)',
  500: 'hsl(227, 50%, 59%)',
  600: 'hsl(227, 42%, 51%)',
  700: 'hsl(228, 45%, 45%)',
  800: 'hsl(230, 49%, 41%)',
  900: 'hsl(232, 51%, 36%)',
  1000: 'hsl(234, 62%, 26%)',
};
export const pink = {
  100: 'hsl(329, 100%, 94%)',
  200: 'hsl(330, 87%, 85%)',
  300: 'hsl(330, 77%, 76%)',
  400: 'hsl(330, 72%, 65%)',
  500: 'hsl(330, 66%, 57%)',
  600: 'hsl(330, 63%, 47%)',
  700: 'hsl(330, 68%, 40%)',
  800: 'hsl(330, 70%, 36%)',
  900: 'hsl(331, 74%, 27%)',
  1000: 'hsl(330, 79%, 20%)',
};
export const red = {
  100: 'hsl(360, 100%, 97%)',
  200: 'hsl(360, 82%, 89%)',
  300: 'hsl(360, 77%, 78%)',
  400: 'hsl(360, 71%, 66%)',
  500: 'hsl(360, 64%, 55%)',
  600: 'hsl(360, 67%, 44%)',
  700: 'hsl(360, 72%, 38%)',
  800: 'hsl(360, 79%, 32%)',
  900: 'hsl(360, 85%, 25%)',
  1000: 'hsl(360, 92%, 20%)',
};
export const yellow = {
  100: 'hsl(45, 100%, 96%)',
  200: 'hsl(45, 90%, 88%)',
  300: 'hsl(45, 86%, 81%)',
  400: 'hsl(43, 90%, 76%)',
  500: 'hsl(43, 89%, 70%)',
  600: 'hsl(42, 78%, 60%)',
  700: 'hsl(42, 63%, 48%)',
  800: 'hsl(43, 72%, 37%)',
  900: 'hsl(43, 77%, 27%)',
  1000: 'hsl(43, 86%, 17%)',
};

export const orange = {
  600: '#FF9D26',
};

// Tema 2
// export const primary = {
//   100: 'hsl(262, 90%, 96%)',
//   200: 'hsl(262, 100%, 88%)',
//   300: 'hsl(262, 100%, 78%)',
//   400: 'hsl(264, 96%, 70%)',
//   500: 'hsl(268, 82%, 60%)',
//   600: 'hsl(273, 80%, 49%)',
//   700: 'hsl(274, 87%, 43%)',
//   800: 'hsl(274, 87%, 37%)',
//   900: 'hsl(274, 87%, 31%)',
//   1000: 'hsl(276, 91%, 23%)',
// };

// export const neutral = {
//   100: 'hsl(216, 33%, 97%)',
//   200: 'hsl(214, 15%, 91%)',
//   300: 'hsl(210, 16%, 82%)',
//   400: 'hsl(211, 13%, 65%)',
//   500: 'hsl(211, 10%, 53%)',
//   600: 'hsl(211, 12%, 43%)',
//   700: 'hsl(209, 14%, 37%)',
//   800: 'hsl(209, 18%, 30%)',
//   900: 'hsl(209, 20%, 25%)',
//   1000: 'hsl(210, 24%, 16%)',
// };

// export const indigo = {
//   1000: 'hsl(276, 91%, 23%)',
//   900: 'hsl(274, 87%, 31%)',
//   800: 'hsl(274, 87%, 37%)',
//   700: 'hsl(274, 87%, 43%)',
//   600: 'hsl(273, 80%, 49%)',
//   500: 'hsl(268, 82%, 60%)',
//   400: 'hsl(264, 96%, 70%)',
//   300: 'hsl(262, 100%, 78%)',
//   200: 'hsl(262, 100%, 88%)',
//   100: 'hsl(262, 90%, 96%)',
// };
// export const pink = {
//   100: 'hsl(171, 82%, 94%)',
//   200: 'hsl(172, 97%, 88%)',
//   300: 'hsl(174, 96%, 78%)',
//   400: 'hsl(176, 87%, 67%)',
//   500: 'hsl(178, 78%, 57%)',
//   600: 'hsl(180, 77%, 47%)',
//   700: 'hsl(182, 85%, 39%)',
//   800: 'hsl(184, 90%, 34%)',
//   900: 'hsl(186, 91%, 29%)',
//   1000: 'hsl(188, 91%, 23%)',
// };
// export const red = {
//   100: 'hsl(360, 100%, 95%)',
//   200: 'hsl(360, 100%, 87%)',
//   300: 'hsl(360, 100%, 80%)',
//   400: 'hsl(360, 91%, 69%)',
//   500: 'hsl(360, 83%, 62%)',
//   600: 'hsl(356, 75%, 53%)',
//   700: 'hsl(354, 85%, 44%)',
//   800: 'hsl(352, 90%, 35%)',
//   900: 'hsl(350, 94%, 28%)',
//   1000: 'hsl(348, 94%, 20%)',
// };
// export const yellow = {
//   100: 'hsl(49, 100%, 96%)',
//   200: 'hsl(48, 100%, 88%)',
//   300: 'hsl(48, 95%, 76%)',
//   400: 'hsl(48, 94%, 68%)',
//   500: 'hsl(44, 92%, 63%)',
//   600: 'hsl(42, 87%, 55%)',
//   700: 'hsl(36, 77%, 49%)',
//   800: 'hsl(29, 80%, 44%)',
//   900: 'hsl(22, 82%, 39%)',
//   1000: 'hsl(15, 86%, 30%)',
// };

export default {
  primary,
  neutral,
  indigo,
  pink,
  red,
  yellow,
};
